import Breadcrumb from "@kopapro/components/commons/breadcrumb/breadcrumb";

export default Breadcrumb;